import { gql } from "@apollo/client"
import { Branding } from "../../typings/types"

export interface WhoAmIResponse {
    whoAmI: {
        email: string
        company: {
            branding: Branding
        }
    }
}

export const WHO_AM_I = gql`
    query whoAmI {
        whoAmI {
            email
            company {
                branding {
                    name
                    contactInfo
                    logo
                    favicon
                    colors {
                        primary
                        secondary
                    }
                }
            }
        }
    }
`
